export default {
    GET_GATES_SUCCESS: (state, data) => {
        state.gates = data
    },
    GET_WORKSPACES: (state, data) => {
        state.workspaces = data
    },
    SET_SENDINGS_SETTINGS: (state, data) => {
        state.sendingsSettings = data
    },
    GET_WORKSPACE_SUCCESS: (state, data) => {
        state.sendingsSettings.workspace = data
    },
    GET_SHIPPING_LABELS_PRINT_HISTORY_REQUEST: state => {
        state.labelsPrintHistoryElementsLoading = true
    },
    GET_SHIPPING_LABELS_PRINT_HISTORY_SUCCESS: (state, data) => {
        state.labelsPrintHistoryElements = data.results
        state.labelsPrintHistoryElementsLoading = false
    },
    GET_SHIPPING_LABELS_PRINT_HISTORY_FAILURE: state => {
        state.labelsPrintHistoryElementsLoading = false
    },
    SET_SHIPPING_LABELS_PRINT_HISTORY_FILTERS: (state, filters) => {
        state.printLabelsHistoryFilters = filters
    },
    CLEAR_SHIPPING_LABELS_PRINT_HISTORY_FILTERS: state => {
        state.printLabelsHistoryFilters = this.setInitialPrintLabelsHistoryFilters()
    }
    
}